
import { IGetWeatherParameters } from "./IGetWeatherParameters";


export class GetWeatherParameters implements IGetWeatherParameters
{
    componentId: number = 0;
    date: Date = new Date();
}
